import {useEffect, useState} from "react";
import {ApiClient} from "@/api/ApiClient";
import {SessionDto} from "@/common/dto/SessionDto";

export function useSession(): SessionDto | undefined {
    const client = ApiClient.instance;
    const [session, setSession] = useState<SessionDto | undefined>(client.getSession());

    useEffect(() => {
        const observer = (session: SessionDto | undefined) => {
            setSession(session);
        };
        client.addObserver(observer);
        return () => client.removeObserver(observer);
    }, []);

    return session;
}
